import React, { ComponentProps, useEffect, useRef, useState } from 'react';

import useWindowSize from '@rooks/use-window-size';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

interface LottieAnimationProps {
  inView: boolean;
  mobileOptions: ComponentProps<typeof Lottie>;
  desktopOptions: ComponentProps<typeof Lottie>;
}

const LottieAnimation = ({
  inView,
  mobileOptions,
  desktopOptions,
}: LottieAnimationProps) => {
  const windowSize = useWindowSize().innerWidth;

  const [played, setPlayed] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const options = (windowSize || 0) > 1023 ? desktopOptions : mobileOptions;

  useEffect(() => {
    if (lottieRef.current && inView && !played) {
      setPlayed(true);
      lottieRef.current.play();
    }
  }, [inView, played]);

  return (
    <div
      onClick={() => {
        if (animationComplete && lottieRef.current) {
          setAnimationComplete(false);
          lottieRef.current.goToAndPlay(0, false);
        }
      }}
      onMouseEnter={() => {
        if (animationComplete && lottieRef.current) {
          setAnimationComplete(false);
          lottieRef.current.goToAndPlay(0, false);
        }
      }}
      onMouseLeave={() => !animationComplete && lottieRef.current?.play()}
      // ref={ref}
    >
      <Lottie
        {...options}
        lottieRef={lottieRef}
        onComplete={() => setAnimationComplete(true)}
      />
    </div>
  );
};

export { LottieAnimation };
